import { Injectable } from '@angular/core';
import { ProjectDetailsApiService } from './project-details-api.service';
import { commonFunctions } from '../../common/classes/common.class';

@Injectable({
  providedIn: 'root'
})
export class ProjectDetailsCascadeService {

  public countryToCurrencyMap: { [country: string]: string } = {};
  public countryToTaxTypeMap: { [country: string]: string } = {};
  public locationToTaxPercentageMap: Map<string, number> = new Map<string, number>();

  public readonly countriesWithDisabledNoVatField: string[] = [
    'United Kingdom',
    'United States of America',
    'India',
    'Singapore',
    'Australia',
    'Canada'
  ];

  constructor(private apiService: ProjectDetailsApiService) {}

  async initializeTaxAndCurrencyMaps(): Promise<void> {
    try {
      const salesTaxDetails = await this.apiService.getSalesTaxDetails();
      if (Array.isArray(salesTaxDetails)) {
        for (const item of salesTaxDetails) {
          const country = item.country;
          const state = item.state;
          const taxPercentage = (item.salesTax || 0) * 100;
          this.countryToCurrencyMap[country] = item.currencyName || '';
          console.log('salesTaxName raw:', JSON.stringify(item.salesTaxName));
          this.countryToTaxTypeMap[country] = (item.salesTaxName || 'VAT').replace(/:?\s*\(%\)\s*$/i, '').trim();          const locationKey = JSON.stringify({ country, state });
          this.locationToTaxPercentageMap.set(locationKey, commonFunctions.round(taxPercentage));
        }
      }
    } catch (e) {
      console.error('Error initializing tax & currency maps:', e);
    }
  }

  getCurrencyForCountry(country: string): string {
    if (!country) return '';
    const cleanCountry = country.trim();
    if (this.countryToCurrencyMap[cleanCountry]) {
      return `(${this.countryToCurrencyMap[cleanCountry]})`;
    }
    for (const [c, currName] of Object.entries(this.countryToCurrencyMap)) {
      if (c.toLowerCase() === cleanCountry.toLowerCase()) {
        return `(${currName})`;
      }
    }
    if (cleanCountry.toLowerCase().includes('singapore')) return '(Singapore Dollars)';
    if (cleanCountry.toLowerCase().includes('united kingdom')) return '(Pounds)';
    if (cleanCountry.toLowerCase().includes('united states')) return '(US Dollars)';
    if (cleanCountry.toLowerCase().includes('india')) return '(Rupees)';
    return '';
  }

  getTaxTypeForCountry(country: string): string {
    if (!country) return 'VAT Rate: (%)';
    const cleanCountry = country.trim();
    if (this.countryToTaxTypeMap[cleanCountry]) {
      return `${this.countryToTaxTypeMap[cleanCountry]}: (%)`;
    }
    for (const [c, taxName] of Object.entries(this.countryToTaxTypeMap)) {
      if (c.toLowerCase() === cleanCountry.toLowerCase()) {
        return `${taxName}: (%)`;
      }
    }
    if (cleanCountry.toLowerCase().includes('singapore')) return 'GST: (%)';
    if (cleanCountry.toLowerCase().includes('united states')) return 'Local Sales Tax: (%)';
    if (cleanCountry.toLowerCase().includes('australia')) return 'GST: (%)';
    if (cleanCountry.toLowerCase().includes('canada')) return 'GST: (%)';
    return 'VAT Rate: (%)';
  }

  getTaxPercentage(country: string, state?: string | null): number {
    if (!country) return 0;
    const cleanCountry = country.trim();
    const cleanState = (state || '').trim();

    const withStateKey = JSON.stringify({ country: cleanCountry, state: cleanState });
    if (this.locationToTaxPercentageMap.has(withStateKey)) {
      return this.locationToTaxPercentageMap.get(withStateKey) || 0;
    }

    const nullStateKey = JSON.stringify({ country: cleanCountry, state: null });
    if (this.locationToTaxPercentageMap.has(nullStateKey)) {
      return this.locationToTaxPercentageMap.get(nullStateKey) || 0;
    }

    const emptyStateKey = JSON.stringify({ country: cleanCountry, state: '' });
    if (this.locationToTaxPercentageMap.has(emptyStateKey)) {
      return this.locationToTaxPercentageMap.get(emptyStateKey) || 0;
    }

    for (const [keyStr, val] of this.locationToTaxPercentageMap.entries()) {
      try {
        const parsed = JSON.parse(keyStr);
        if (parsed.country && parsed.country.toLowerCase() === cleanCountry.toLowerCase()) {
          if (!cleanState || (parsed.state && parsed.state.toLowerCase() === cleanState.toLowerCase())) {
            return val;
          }
        }
      } catch (e) {}
    }

    if (cleanCountry.toLowerCase().includes('singapore')) return 8;
    if (cleanCountry.toLowerCase().includes('united kingdom')) return 20;
    if (cleanCountry.toLowerCase().includes('india')) return 18;

    return 0;
  }

  isNoVatDisabledForCountry(country: string): boolean {
    if (!country) return false;
    return this.countriesWithDisabledNoVatField.includes(country);
  }
}
